import "./BoatCard.scss";

const BACKEND = process.env.REACT_APP_BACKEND;

function BoatCard({ boat, onToggle, onEdit, onBook, onDelete }) {
  return (
    <div className="admin-card" key={boat._id}>
      {boat.images?.[0] ? (
        <img
          src={`${BACKEND}/images/boats/${boat.images[0]}`}
          alt={boat.name}
        />
      ) : (
        <div className="no-image">No image</div>
      )}
      <h3>{boat.name}</h3>
      <p className="boat-meta">{boat.type} · {boat.capacity} pax</p>
      <div className="toggle-row">
        <label className="switch">
          <input
            type="checkbox"
            checked={boat.status === "available"}
            onChange={() => onToggle(boat._id, boat.status)}
          />
          <span className="slider"></span>
        </label>
        <span className={`status-badge ${boat.status}`}>{boat.status}</span>
      </div>
      <div className="card-actions">
        <button className="edit-btn" onClick={() => onEdit(boat)}>Edit</button>
        <button className="book-btn" onClick={() => onBook(boat)}>Book</button>
        <button className="delete-btn" onClick={() => onDelete(boat._id)}>Delete</button>
      </div>
    </div>
  );
}

export default BoatCard;
